import { render, staticRenderFns } from "./Museum.vue?vue&type=template&id=014a8d08&scoped=true&"
import script from "./Museum.vue?vue&type=script&lang=js&"
export * from "./Museum.vue?vue&type=script&lang=js&"
import style0 from "./Museum.vue?vue&type=style&index=0&id=014a8d08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a8d08",
  null
  
)

export default component.exports